<template>
  <v-toolbar
    app
    dark
    flat
  >
    <v-toolbar-side-icon
      class="hidden-md-and-up"
      @click="toggleDrawer"
    />
    <v-container
      mx-auto
      py-0
    >
      <v-layout>
        <v-img
          :src="require('@/assets/logo.webp')"
          class="mr-5"
          contain
          height="48"
          width="48"
          max-width="48"
          @click="$vuetify.goTo(0)"
        />
        <v-btn
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          class="ml-0 hidden-sm-and-down"
          flat
          @click="onClick($event, item)"
        >
          {{ link.name }}
        </v-btn>
        <v-btn flat to="/Login" v-if="!isLoggedIn">
          Login
        </v-btn>

  <div class="text-xs-center" v-if="isLoggedIn">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          dark
          v-on="on"
        >
          WelcomeBack
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          @click="Logout"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>

        <v-spacer />
        <v-text-field
          v-model="search"
          class="search"
          append-icon="mdi-magnify"
          flat
          hide-details
          solo-inverted
          style="max-width: 300px;"
        />
      </v-layout>
    </v-container>
  </v-toolbar>
</template>

<script>
import firebase from 'firebase'

  // Utilities
  import {
    mapGetters,
    mapMutations
  } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['links']),
      filterItem : function(){
      return this.item.filter((item) =>{
        return item.name.match(this.search);
      })
    },
    },
    
data(){
        return{
          search:'',
      items: [
        { title: 'Logout'},
        { title: 'PersonalCenter' },
        { title: 'Test1' },
        { title: 'Test2' }
      ],
links: [
{
name: 'Home',
to: '/'
},
{
name: 'RecentDiscussion',
to: '/meetups'
},
{
name: 'personalcenter',
to: '/personalcenter'
},
{
name: 'Video',
to: '/videoPlayer'
},
{
name: 'WriteNew',
to: '/Discussion'
},
{
name: 'More?',
to: '/searchpanel'
},
],
search: '',
isLoggedIn: false,
currentUser: false,
        }
      },
      created(){
if(firebase.auth().currentUser){
this.isLoggedIn = true;
this.currentUser = firebase.auth().currentUser.email;
}
},
    methods: {
      btn:function(){
  		
  		var search = this.search;
			if (search) {
			 this.searchData =  this.products.filter(function(product) {
			 	console.log(product)
				return Object.keys(product).some(function(key) {
					console.log(key)
			  	return String(product[key]).toLowerCase().indexOf(search) > -1
			})
			})
			}
			
  	},

      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()

        if (item.to || !item.href) return

        this.$vuetify.goTo(item.href)
      },
      Logout: function () {
      firebase
      .auth()
      .signOut()
      .then(() => {
       this.$router.go({path: this.$router.path});
       });  
      }
    }
  }
</script>

<style>
</style>
